import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useQuery() {
  const { search } = useLocation();

  return useMemo(() => {
    const query = new URLSearchParams(search);

    return Array.from(query.keys()).reduce((acc, key) => {
      acc[key] = query.get(key)!;
      return acc;
    }, {} as Record<string, string>);

  }, [search]);
}